export const headers = [
  { key: "slNo", label: "SL No.", isShortable: true, isVisible: true },
  // { key: "ecode", label: "Employee Code", isClickable: true, isShortable: true, isVisible: true },
  {
    key: "name",
    label: "Branch Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    isClickable: true,
  },
  {
    key: "dateOfEstablished",
    label: "Date of Established",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "mobileNo",
    label: "Mobile No",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
  {
    key: "emailId",
    label: "Email Id",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "contactPerson",
    label: "Contact Person",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "address",
    label: "Address",
    align: "left",
    isShortable: false,
    isVisible: false,
  },

  {
    key: "status",
    label: "Status",
    align: "left",
    isClickable: false,
    isShortable: true,
    isVisible: false,
  },
];

export const rows = [
  {
    slNo: 1,
    status: "Active",
    name: "Bangalore Branch",
    mobileNo: "(987) 654-3210",
    emailId: "bangalore.branch@techwens.com",
    address: "123 MG Road, Bangalore, Karnataka",
    contactPerson: "Sanjoy Das",
    dateOfEstablished: "01-11-2020",
  },
  {
    slNo: 2,
    status: "Active",
    name: "Mumbai Branch",
    mobileNo: "(876) 543-2109",
    emailId: "mumbai.branch@techwens.com",
    address: "456 Marine Drive, Mumbai, Maharashtra",
    contactPerson: "Rajesh Kumar",
    dateOfEstablished: "15-08-2018",
  },
  {
    slNo: 3,
    status: "Inactive",
    name: "Chennai Branch",
    mobileNo: "(765) 432-1098",
    emailId: "chennai.branch@techwens.com",
    address: "789 Mount Road, Chennai, Tamil Nadu",
    contactPerson: "Priya Iyer",
    dateOfEstablished: "22-05-2019",
  },
  {
    slNo: 4,
    status: "Active",
    name: "Kolkata Branch",
    mobileNo: "(654) 321-0987",
    emailId: "kolkata.branch@techwens.com",
    address: "10 Park Street, Kolkata, West Bengal",
    contactPerson: "Arindam Ghosh",
    dateOfEstablished: "30-12-2017",
  },
  {
    slNo: 5,
    status: "Active",
    name: "Delhi Branch",
    mobileNo: "(543) 210-9876",
    emailId: "delhi.branch@techwens.com",
    address: "50 Connaught Place, New Delhi",
    contactPerson: "Neha Singh",
    dateOfEstablished: "12-06-2016",
  },
  {
    slNo: 6,
    status: "Inactive",
    name: "Hyderabad Branch",
    mobileNo: "(432) 109-8765",
    emailId: "hyderabad.branch@techwens.com",
    address: "25 Jubilee Hills, Hyderabad, Telangana",
    contactPerson: "Ravi Verma",
    dateOfEstablished: "05-09-2021",
  },
];

//Holiday-list

export const HolidayHeaders = [
  { key: "slNo", label: "SL No.", isShortable: true, isVisible: true },
  {
    key: "holidayName",
    label: "Holiday Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
  },
  {
    key: "date",
    label: "Date",
    align: "left",
    isShortable: true,
    isVisible: true,
  },
  {
    key: "holidayDay",
    label: "Day",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
  {
    key: "region",
    label: "Region",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
];

export const HolidayRows = [
  {
    slNo: 1,
    holidayName: "Durga Puja",
    date: "22-10-2024",
    holidayDay: "Monday",
    region: "West Bengal",
  },
  {
    slNo: 2,
    holidayName: "Kali Puja",
    date: "01-11-2024",
    holidayDay: "Friday",
    region: "West Bengal",
  },
  {
    slNo: 3,
    holidayName: "Diwali",
    date: "12-11-2024",
    holidayDay: "Wednesday",
    region: "National",
  },
];
